import React from 'react';
import { CELEBRITY_EVENT_MAX_ORDER_ALERT } from 'src/celebrity-event/Content';
import { useHasReachedCelebrityOrderLimit } from 'src/celebrity-event/hooks/useHasReachedCelebrityOrderLimit';
import { OrderShefFragment } from 'src/gqlReactTypings.generated.d';

interface IProps {
  className?: string;
  shef: OrderShefFragment;
}

export const CelebrityEventMaxOrderAlertBanner: React.FC<IProps> = ({ className, shef }) => {
  const [hasReachedCelebrityOrderLimit] = useHasReachedCelebrityOrderLimit({ shef });

  if (!shef.celebrityEventType || !hasReachedCelebrityOrderLimit) return null;

  return (
    <div className={`center flex w-full flex-row content-center justify-center bg-jackfruit-50 p-4 ${className}`}>
      <span className='self-center'>{CELEBRITY_EVENT_MAX_ORDER_ALERT[shef.celebrityEventType]}</span>
    </div>
  );
};
